// extracted by mini-css-extract-plugin
module.exports = {"startGameButton":"Login_startGameButton__1sz_9","homeContainer":"Login_homeContainer__3_vf8","heroContainer":"Login_heroContainer__S-bkn"};